var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-relative d-flex container",style:({
    padding: _vm.blockPadding,
    minHeight: _vm.imageUrl ? 'auto' : '200px',
    justifyContent: _vm.imageAlign
  })},[(_vm.imageUrl)?_c('img',{staticClass:"image-block__image",attrs:{"src":_vm.imageUrl,"width":_vm.width}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }